import * as Sentry from '@sentry/react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import { Layout } from '@/entities/Layout';
import { ErrorPage } from '@/pages/ErrorPage';
import { HomePage } from '@/pages/Home';
import { authLoader } from '@/router/loaders/authLoader';
import { cabinetLoader } from '@/router/loaders/cabinetLoader';
import { cabinetPaymentLoader } from '@/router/loaders/cabinetPaymentLoader';
import { indexRedirect } from '@/router/loaders/indexRedirect';
import { notificationsLoader } from '@/router/loaders/notificationsLoader';
import { repeatLoanLoader } from '@/router/loaders/repeatLoanLoader';
import { signupLoader } from '@/router/loaders/signupLoader';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export default sentryCreateBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="*" loader={indexRedirect} errorElement={<ErrorPage />} />
      <Route element={<Layout />} errorElement={<ErrorPage />}>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/auth"
          lazy={() => import(/* webpackPrefetch: true */ '@/pages/Auth')}
          loader={authLoader}
        />
        <Route
          path="/signup"
          lazy={() => import(/* webpackPrefetch: true */ '@/pages/Signup')}
          loader={signupLoader}
        />
        <Route loader={cabinetLoader}>
          <Route
            path="/cabinet"
            lazy={() => import(/* webpackPrefetch: true */ '@/pages/Cabinet')}
          />
          <Route
            path="/cabinet/loan-calculator"
            loader={repeatLoanLoader}
            lazy={() =>
              import(/* webpackPrefetch: true */ '@/pages/LoanCalculator')
            }
          />
          <Route
            path="/cabinet/choose-loan-type"
            loader={repeatLoanLoader}
            lazy={() =>
              import(/* webpackPrefetch: true */ '@/pages/LoanPurpose')
            }
          />
          <Route
            path="/cabinet/loan-payment"
            loader={cabinetPaymentLoader}
            lazy={() =>
              import(/* webpackPrefetch: true */ '@/pages/PaymentSubject')
            }
          />
          <Route
            path="/verification-result"
            lazy={() => import('@/pages/VerificationResult')}
          />
        </Route>
        <Route
          path="/notifications"
          loader={notificationsLoader}
          lazy={() => import('@/pages/Notifications')}
        />
        <Route
          path="/payments-info"
          lazy={() => import('@/pages/PaymentsInfo')}
        />
        <Route
          path="/loan-conditions"
          lazy={() => import('@/pages/LoanConditions')}
        />
        <Route
          path="/payment"
          lazy={() =>
            import(/* webpackPrefetch: true */ '@/pages/PaymentCommon')
          }
        />
        <Route path="/feedback" lazy={() => import('@/pages/Feedback')} />
        <Route path="/complaint" lazy={() => import('@/pages/Compliant')} />
        <Route
          path="/how-get-money"
          lazy={() => import('@/pages/HowGetMoney')}
        />
        <Route path="/faq" lazy={() => import('@/pages/FAQ')} />
        <Route path="/contacts" lazy={() => import('@/pages/Contacts')} />
        <Route
          path="/debt-disposal"
          lazy={() => import('@/pages/DebtDisposal')}
        />
        <Route
          path="/mock/:date/:iin"
          lazy={() => import('@/pages/BackdoorLogin')}
        />
      </Route>
      <Route
        path="/statements"
        lazy={() => import(/* webpackPrefetch: true */ '@/pages/Statement')}
      />
    </>
  )
);
